import SEO from '../components/SEO';
import './PageShared.css';
import './Handelsbetingelser.css';

const sections = [
  {
    title: 'Løbende betalinger og medlemskab',
    body: `Ved køb af medlemskaber og andre løbende ydelser godkender kunden, at Little-Stars er berettiget til løbende at gennemføre transaktioner på kundens betalingskort.

Kunden giver med aftalens indgåelse tilladelse til, at Little-Stars må gennemføre én betalingstransaktion for hver betalingsperiode, så længe medlemskabet løber. Betalingstransaktionen og medlemskabet gennemføres løbende den 1. i måneden. Little-Stars er alene berettiget til at gennemføre betalingstransaktioner på medlemskabets beløb for den kommende medlemskabsperiode. Eventuelle yderligere beløb skal særskilt godkendes af kunden.

Efter hver enkelt gennemført betalingstransaktion fremsendes kvittering til den e-mail adresse, der er oplyst ved køb af medlemskabet.`,
  },
  {
    title: 'Opsigelse',
    body: `Ens medlemskabsaftale er altid gældende fra samme dato som købsdato og er gældende, indtil det opsiges af Little-Stars eller kunden. Opsigelse kan ske med løbende måned + én måned fra købsdato efter aftalens indgåelse. Det vil sige, at man altid kun hæves for én medlemsperiode efter opsigelse.

Opsigelse af medlemskabsaftale skal ske via egen medlemsprofil, som er modtaget ved oprettelse.`,
  },
  {
    title: 'Bero',
    body: `Medlemskabet kan sættes i bero i én måned hver sjette måned. Ved ny påbegyndelse af medlemskab er opsigelse løbende måned + 1 måned gældende fra købsdato. Det er gratis at sætte i bero.

Medlemskabet kan ikke opsiges under bero, og et medlemskab som er opsagt, kan ikke sættes i bero.`,
  },
  {
    title: 'Prisændringer',
    body: `Den månedlige medlemspris er oplyst ved aftalens indgåelse og kan fra Little-Stars ændres med et varsel på 45 dage til udgangen af en måned. Varsel fremsendes til den e-mail adresse, der er oplyst ved opstart/køb af abonnementet.`,
  },
  {
    title: 'Legeområde og ansvar',
    body: `Legeområde er forbeholdt medlemmer eller betalende, og alt ophold på legeområdet er på eget ansvar. Voksne skal selv holde øje med deres børn.

Medlemskabet kan være underlagt særskilte vilkår/reglement, som oplyses ved opstart/køb af medlemskabet.`,
  },
  {
    title: 'No-show og hold',
    body: `Som medlem giver du Little-Stars adgang til at hæve et "no show fee" ved manglende fremmøde til tilmeldte hold. Efter hver enkelt gennemført betalingstransaktion fremsendes kvittering til den oplyste e-mail. Såfremt man skulle have fået fejlregistreret et "no show fee", skal man henvende sig senest 7 dage efter registreringen.

Hold med under 3 tilmeldte deltagere aflyses senest 2 timer inden holdstart. I sommerferien - primært juli - vil hold være reduceret grundet ferie hos personale og undervisere. Der vil være lukket mellem jul og nytår, medmindre andet fremgår.`,
  },
  {
    title: 'Force majeure',
    body: `I tilfælde af en pandemi, epidemi, force majeure eller lignende tilstand, som resulterer i tvunget lukning af Little-Stars, forlænges kundens medlemskab med det antal dage, lukket periode varer, ved opsigelse af medlemskabet. Kunden skal selv gøre Little-Stars opmærksom på dette ved opsigelse.`,
  },
  {
    title: 'Fortrydelsesret',
    body: `I henhold til forbrugeraftaleloven ydes der 14 dages fortrydelsesret på varer købt via hjemmesiden. Fortrydelsen kan ikke tages i brug, hvis abonnementet er taget i brug. Betalinger for deltagelse i aktiviteter samt billetter til arrangementer kan som udgangspunkt ikke refunderes, medmindre andet er anført i beskrivelsen af aktiviteten.`,
  },
  {
    title: 'Nyhedsbrev',
    body: `Ved oprettelse af profil på Little-Stars hjemmeside accepterer man at modtage nyhedsbreve fra Little-Stars. Man kan til enhver tid opsige modtagelse af disse.`,
  },
  {
    title: 'Personoplysninger og GDPR',
    body: `Little-Stars har behov for at indsamle, registrere og behandle personoplysninger for at kunne gennemføre oprettelse af medlemskab. Little-Stars indsamler kun de oplysninger, der er nødvendige for levering af denne ydelse.

De personoplysninger der behandles er navn, tlf.nr., adresse og e-mail adresse. Der registreres ikke personfølsomme oplysninger såsom CPR-nr. eller konto-/kortnumre.

Ved handel gennem www.little-stars.dk registreres personoplysninger med det formål at kunne levere det bestilte medlemskab eller bestilling. Registrerede oplysninger opbevares i 5 år af hensyn til regnskabsmateriale, hvorefter oplysningerne slettes.

I overensstemmelse med persondataloven vil Little-Stars, som dataansvarlig, give enhver der begærer det, meddelelse om: 1) hvilke oplysninger der behandles, 2) behandlingens formål, 3) hvem der måtte modtage oplysningerne samt 4) hvorfra oplysningerne stammer. En registreret kan til enhver tid gøre indsigelse mod behandling af oplysninger om vedkommende.`,
  },
];

export default function Handelsbetingelser() {
  return (
    <main className="page">
      <SEO
        title="Handelsbetingelser"
        path="/handelsbetingelser"
        description="Læs Little-Stars' handelsbetingelser for medlemskaber, opsigelse, fortrydelsesret og GDPR."
        noindex={true}
      />

      <div className="page-hero">
        <div className="page-hero-bg" style={{ '--c1': '#7DCFCA', '--c2': '#B8A0D4' }} />
        <div className="page-hero-content">
          <div className="page-label">Juridisk</div>
          <h1>Handelsbetingelser</h1>
          <p>Vilkår for køb af medlemskaber og ydelser hos Little-Stars.</p>
        </div>
      </div>

      <section className="content-section bg-white">
        <div className="container hb-container">

          <div className="hb-company">
            <strong>Little-Stars</strong>
            <span>Hovedvejen 8, 8920 Randers NV</span>
            <span>E-mail: <a href="mailto:info@little-stars.dk">info@little-stars.dk</a></span>
            <span>CVR-nr.: 45984052</span>
          </div>

          {sections.map(s => (
            <div className="hb-section" key={s.title}>
              <h2>{s.title}</h2>
              {s.body.split('\n\n').map((para, i) => (
                <p key={i}>{para}</p>
              ))}
            </div>
          ))}

        </div>
      </section>

    </main>
  );
}
